/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/KanbanSwimLane'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./KanbanSwimLane'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.IKanbanBoard = factory(root.BpmbuildDevelopmentappspotcom.ApiClient, root.BpmbuildDevelopmentappspotcom.KanbanSwimLane);
  }
}(this, function(ApiClient, KanbanSwimLane) {
  'use strict';

  /**
   * The IKanbanBoard model module.
   * @module model/IKanbanBoard
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>IKanbanBoard</code>.
   * @alias module:model/IKanbanBoard
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>IKanbanBoard</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IKanbanBoard} obj Optional instance to populate.
   * @return {module:model/IKanbanBoard} The populated <code>IKanbanBoard</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('sequence'))
        obj.sequence = ApiClient.convertToType(data['sequence'], 'Number');
      if (data.hasOwnProperty('swimLaneList'))
        obj.swimLaneList = ApiClient.convertToType(data['swimLaneList'], [KanbanSwimLane]);
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
    }
    return obj;
  }

  /**
   * @member {Number} sequence
   */
  exports.prototype.sequence = undefined;

  /**
   * @member {Array.<module:model/KanbanSwimLane>} swimLaneList
   */
  exports.prototype.swimLaneList = undefined;

  /**
   * @member {String} title
   */
  exports.prototype.title = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/IKanbanBoard.js